import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useLocale from '../hooks/useLocale';
import './UserFooter.css';

const UserFooter = () => {
  const { getCurrentLanguage } = useLocale();
  const lang = getCurrentLanguage();
  const ucpBaseUrlRaw =
    (typeof process !== 'undefined' && process?.env?.REACT_APP_UCP_BASE_URL) ||
    'https://ucp.academy';

  const ucpHomeUrl = String(ucpBaseUrlRaw || '').replace(/\/$/, '');

  const t =
    lang === 'ru'
      ? {
          policy: 'Политика конфиденциальности',
          support: 'Поддержка в Telegram',
          emailSupport: 'Почта поддержки support@ucp.academy',
        }
      : {
          policy: 'Privacy policy',
          support: 'Support in Telegram',
          emailSupport: 'Support email support@ucp.academy',
        };

  const policyHref = `/policy_${lang}.pdf`;

  useEffect(() => {
    const ucpSpan = document.querySelector('.footer .logo span:first-child');
    if (!ucpSpan) return;

    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = ucpHomeUrl;
    };

    const onKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = ucpHomeUrl;
      }
    };

    ucpSpan.addEventListener('click', onClick);
    ucpSpan.addEventListener('keydown', onKeyDown);

    ucpSpan.setAttribute('role', 'link');
    ucpSpan.setAttribute('tabindex', '0');
    ucpSpan.setAttribute('aria-label', 'UCP');
    ucpSpan.style.cursor = 'pointer';

    return () => {
      ucpSpan.removeEventListener('click', onClick);
      ucpSpan.removeEventListener('keydown', onKeyDown);
    };
  }, [ucpHomeUrl]);

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__column">
          <Link to="/dashboard" className="logo footer__logo">
            <span>ucp</span>
            <span>Review</span>
          </Link>

          <a className="footer__link" href={policyHref} download>
            {t.policy}
          </a>

          <a
            className="footer__link"
            href="https://t.me/ucp_sudo_bot"
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            {t.support}
          </a>

          <a className="footer__link" href="mailto:support@ucp.academy" rel="nofollow">
            {t.emailSupport}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;
